import { useAuth } from './useAuth';

// Feature 011 — exposes the must-change flag + a callback the page calls when
// the change has succeeded so the AuthContext clears the gate locally
// (avoiding a token refresh).
export function useForcedPasswordChange() {
  const { mustChangePassword, clearMustChangePassword } = useAuth();
  return { mustChangePassword, onPasswordChanged: clearMustChangePassword };
}
